import React from 'react';
import '../../scss/components/_podcast-card.scss'


const PodcastCard = props => (
    <div className="contentBlock d-flex justify-content-between flex-wrap gridContainer">
        <div className="verticalPodcastColumn mb-0 innerPodcastContainer" style={cardStyle(props.cardColor)}>
            <a href={props.link} target="_blank">
                <div class="podcast-image-container">
                    <div className="icon">
                        <img src="/press/play.svg" alt="Play icon" />
                    </div>
                    <div class="podcast-image" style={imgUrl(props.urlImg)}></div>
                </div>
            </a>
            <div className="podcast-container">
                <div className="podcast-header">
                    <p class="podcast-subtitle">{props.subtitle}</p>
                    <h2 class="podcast-title">{props.title}</h2>
                </div>
                <div className="podcast-body">
                    <p class="podcast-description">{props.description}</p>
                </div>
                <div className="podcast-link">
                    <img src={props.authorImage} alt={props.authorName} />
                    <div className="d-flex flex-column">
                        <p className="my-0"><b>{props.authorName}</b></p>
                        <p className="mb-0">{props.isVideo ? "Watch on" : "Listen on"} <br/> <a href={props.link} className="ctaStandard textInline" target="_blank">{props.authorVideoTitle}</a></p>
                    </div>
                </div>
            </div>
 
        </div>
    </div>
);

const imgUrl = (urlImg) => ({
    backgroundImage: `url(${urlImg})`

})

const cardStyle = (cardColor) => ({
    background: cardColor

})
export default PodcastCard;



